type FileListItem = {
  file_type?: unknown
  file?: {
    originFileObj?: unknown
  }
  originFileObj?: unknown
}

type DataWithFileList = {
  file_list?: FileListItem[] | null
}

export const createFormData = (data: unknown, file_key?: string | null) => {
  const formData = new FormData()

  Object.entries(data as object).forEach(([key, value]) => {
    if (key === "file_list" || value == null) return

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (
          item !== null &&
          typeof item === "object" &&
          item.constructor === Object
        ) {
          formData.append(key, JSON.stringify(item))
        } else {
          formData.append(key, item as string | Blob)
        }
      })
    } else if (typeof value === "object" && value.constructor === Object) {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value as string | Blob)
    }
  })

  const dataWithFileList = data as DataWithFileList

  if (dataWithFileList.file_list) {
    dataWithFileList.file_list.forEach((file, index) => {
      if (file?.file_type) {
        formData.append(
          `${file_key || "files"}[${index}].file`,
          (file as { file: { originFileObj: Blob | File } }).file.originFileObj
        )
        formData.append(
          `${file_key || "files"}[${index}].file_type`,
          file?.file_type as string | Blob
        )
      } else {
        formData.append(file_key || "files", file.originFileObj as Blob | File)
      }
    })
  }

  return formData
}
